import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../styles/slider.css";
import { Card } from "./CommonComponents";
import { Star } from "./svgs";
import contents from "../utills/page_contents.json";

const Title = styled.h1`
  position: absolute;
  top: 70px;
  font-size: 0.9rem;
  font-weight: 600;
`;

const Annotation = styled.div`
  position: absolute;
  top: -10px;
  font-size: 0.75rem;
  @media (max-width: 1024px) {
    position: relative;
    margin: 16px 0px;
    font-size: 0.6rem;
    right: 0px;
  } ;
`;

function PriceCarousel() {
  const { support_devices } = contents;
  return (
    <>
      <Title>SUPPORT DEVICE LIST</Title>
      <Swiper
        modules={[Pagination, Navigation]}
        slidesPerView={1}
        pagination={{
          clickable: true,
          bulletElement: "svg",
        }}
        navigation={true}
        scrollbar={{ draggable: true }}
      >
        {support_devices.map((device, index) => (
          <SwiperSlide key={device.type}>
            <Card index={index} id={`price_card${index}`}>
              <Star />
              <h1>{device.type}</h1>
              {device.device_models.map((model) => (
                <span key={model}>{model}</span>
              ))}
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
      <Annotation>*Keep updating for new devices</Annotation>
    </>
  );
}

export default PriceCarousel;
